export default "__VITE_ASSET__BzpcaAR8__"